/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var PlaceholderView = require('common/views/PlaceholderView');

var DepEntityTrackingSectionView = require('../views/DepEntityTrackingSectionView');
var GetEntityTrackingsByEntity = require('../services/GetEntityTrackingsByEntity');
var GetEntityRiskMatricesByEntity = require('../services/GetEntityRiskMatricesByEntity');

module.exports = {
  channel: 'dp',

  event: 'build:entity-tracking-view',

  builder: function(entityId) {
    return new PlaceholderView({
      viewPromise: buildEntityTrackingView(entityId)
    });
  }
};

function buildEntityTrackingView(entityId) {
  var deferred = $.Deferred();
  $.when(GetEntityTrackingsByEntity(entityId), GetEntityRiskMatricesByEntity(entityId))
    .done(function(tracking, riskMatrix) {
      deferred.resolve(
        new DepEntityTrackingSectionView({
          model: new Backbone.Model({
            tracking: tracking,
            riskMartrix: riskMatrix
          })
        })
      );
    })
    .fail(function(err) {
      deferred.reject(err);
    });
  return deferred.promise();
}
